import { render, staticRenderFns } from "./SearchGameList.vue?vue&type=template&id=174dc7c0&scoped=true"
import script from "./SearchGameList.vue?vue&type=script&lang=js"
export * from "./SearchGameList.vue?vue&type=script&lang=js"
import style0 from "./SearchGameList.vue?vue&type=style&index=0&id=174dc7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174dc7c0",
  null
  
)

export default component.exports